export const uri = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/i
export const endlineWordsHash = /#\S*$/i
export const endlineHash = /#$/i
export const endlineWordsAt = /@\S*$/i
export const endlineAt = /@$/i
